import { useEffect } from 'react'

import { shallowEqual, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { shouldShowZendeskOnRoute } from 'app/utils/widgets/zendeskVisibility'

// Minimal Redux state interface for the session slice
interface RootState {
  session: {
    currentAgency: unknown | null
    currentTeam: unknown | null
  }
}

/**
 * Manages Zendesk widget visibility based on route and team context.
 */
export function ZendeskManager(): null {
  const location = useLocation()
  const { currentAgency, currentTeam } = useSelector(
    (state: RootState) => ({
      currentAgency: state.session.currentAgency,
      currentTeam: state.session.currentTeam,
    }),
    shallowEqual,
  )

  useEffect(() => {
    const hasTeamContext = !!(currentAgency || currentTeam)
    const shouldShowOnRoute = shouldShowZendeskOnRoute(location.pathname)

    const shouldShowZendesk = hasTeamContext || shouldShowOnRoute
    const isCurrentlyHidden = document.body.classList.contains('hide-zendesk')

    // Only update the DOM if the class state needs to change
    if (shouldShowZendesk && isCurrentlyHidden) {
      document.body.classList.remove('hide-zendesk')
    } else if (!shouldShowZendesk && !isCurrentlyHidden) {
      document.body.classList.add('hide-zendesk')
    }
  }, [location.pathname, currentAgency, currentTeam])

  return null
}
